import { Controller } from "@hotwired/stimulus"

import { formatPrice } from "@/helpers/price_format"

export default class extends Controller<HTMLElement> {
  static targets = ["submitButton", "totalPrice"]
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly totalPriceTarget: HTMLElement

  setPriceTarget(value: number): void {
    this.totalPriceTarget.textContent = formatPrice(value)
  }

  toggleEnabled(enabled: boolean): void {
    this.submitButtonTarget.disabled = !enabled
  }
}
